import React, { useCallback, useEffect, useState } from "react"
import { useAuth } from "../../auth/AutoContextProvider"
import { apiErrorCodes } from "../../common/components/defaults"
import { v4 as uuidv4 } from 'uuid'
import { buildMiiPrompts, buildMiiFirstNameList , buildMiiLastNameList } from "../defaults.js"
import { useBuildMiiTest } from "../BuildMiiServiceTestProvider"
import TemplateUploader from "../../common/components/TemplateUploader";
import { useCommon } from "../../common/CommonServiceProvider";


const BuildMiiTestPage = (props) => {
    const [{getBuildMiiOneShotJobDescriptionRequest, getBuildMiiTypeFormResponseRequest,getBuildMiiTypeFormConfigurationRequest}] = useBuildMiiTest()
    const [_, {sso, getCookie, setCookie, getFinalGuestToken}] = useAuth()
    const [{sendEmail, refreshLimitToken, sendToHubspot}] = useCommon()
    const uId_token = uuidv4();
    const [typeFormFieldObject, setTypeFormFieldObject] = useState([])
    const [finalTypeFormObject, setFinalTypeFormObject] = useState([])
    const refresh = getCookie('tkn-ath-rfrsh')

    const dummyData = [
        {index: 0, id: 'abc', value: 'tester'},
        {index: 1, id: 'def', value: 'tester'},
        {index: 2, id: 'ghi', value: ''},
        {index: 3, id: 'jkl', value: ''},
        {index: 4, id: 'mno', value: ''},
        {index: 5, id: 'pqr', value: {labels:['Goal-oriented', 'Attention to detail', 'Team Player']}},
        {index: 6, id: 'stu', value: 'tester'},
    ]

    const getTypeFormConfigurationRequest = useCallback(async (formId) => {
        try {
          const response = await getBuildMiiTypeFormConfigurationRequest(formId);
          if (response?.status === 200) {
            const getFields = response.data.fields.map((field, index) => {
              const fieldObj = {
                index: index,
                id: field.id,
                title: field.title,
                type: field.type,
              };
              return fieldObj;
            });
            const filteredFields = getFields.filter((field) => field.type !== "statement");
            
            if (response?.headers['rate-limit-token'] && response?.headers['rate-limit-refresh-token']) {
              sso(response?.headers['rate-limit-token'], response?.headers['rate-limit-refresh-token']);
            }

            return filteredFields;
          }else{
            console.log("Failed Response", response)
            refreshLimitToken(refresh)
          }
        } catch (error) {
          console.error("An error occurred:", error);
          // refreshLimitToken(refresh, getFinalGuestToken,sso)
          refreshLimitToken(refresh)
        }
    }, []);

    const getTypeFormRequest = useCallback(async (uuid, typeFormFieldObject) => {
        try {
          const typeFormQuestionObject = typeFormFieldObject;
          const response = await getBuildMiiTypeFormResponseRequest(uuid);
          if (response?.status === 200) {
            const answers = response?.data?.response?.answers;
            const newArray = typeFormQuestionObject.map((question) => {
              const { id, index } = question;
              const { value = "" } = answers.find(({ questionId }) => questionId === id) || {};
              return { index, id, value };
            });
      
            if (newArray.length) {
              setFinalTypeFormObject([...newArray]);
            }

            if (response?.headers['rate-limit-token'] && response?.headers['rate-limit-refresh-token']) {
              sso(response?.headers['rate-limit-token'], response?.headers['rate-limit-refresh-token']);
            }

            return newArray;
          }else{
            console.log("Failed Response", response)
            refreshLimitToken(refresh)
            return response

          }
        } catch (error) {
            console.error("An error occurred:", error);
            refreshLimitToken(refresh)
        }
    }, []);


    const getJobDescriptionRequest = useCallback(async (prompt, answers) => {
        try {
          const request = await getBuildMiiOneShotJobDescriptionRequest(prompt, answers);
          if (!request.error) {
            if (request?.rateLimitRefreshToken && request?.rateLimitToken) {
              sso(request?.rateLimitToken, request?.rateLimitRefreshToken);
            }
            return request;
          } else {
            const errorCode = request?.error?.data?.error?.code;
            const errorDetails = apiErrorCodes.find((errorCodeObj) => errorCodeObj.code === errorCode);
            if (errorDetails) {
              const errorMessage = `Error Overview: ${errorDetails.overview}\nCause: ${errorDetails.cause}\nSolution: ${errorDetails.solution}`;
              console.log("error message", errorMessage)
            }
            return errorDetails
          }
        } catch (error) {
          console.error("An error occurred:", error);
          refreshLimitToken(refresh)
        }
      }, []);

    const handleTestResponseService = useCallback(async () => {
        getTypeFormRequest(uId_token,typeFormFieldObject)
        .then((response) =>{
            console.log("Response Service", response)
            if (response?.headers['rate-limit-token'] && response?.headers['rate-limit-refresh-token']) {
              sso(response?.headers['rate-limit-token'], response?.headers['rate-limit-refresh-token']);
            }
        })
        .catch((error)=> {
            console.log("error",error)
            refreshLimitToken(refresh)
        })
    }, []);

    const handleTestConfigService = useCallback(async() => {
        const formId = process.env.REACT_APP_TYPEFORM_FORM_ID
        if(process.env.REACT_APP_TYPEFORM_FORM_ID){
            getTypeFormConfigurationRequest(formId)
            .then((response) => {
                console.log("Configuration Service Response", response)
              })
            .catch((error)=> {
                console.log("error",error)
            })
        }
    }, []);

    const handleTestChatService = useCallback(async() => {
        const prompt = buildMiiPrompts.entryPrompt
        const answerObject = dummyData || finalTypeFormObject
        getJobDescriptionRequest(prompt, answerObject)
        .then((response)=> {
            console.log("Chat Service Response", response)
            if (response?.rateLimitRefreshToken && response?.rateLimitToken) {
              sso(response?.rateLimitToken, response?.rateLimitRefreshToken);
            }
        })
        .catch((error)=> {
            console.log("error", error)
            refreshLimitToken(refresh)
        })
    }, []);

    const handleTestSendEmailService = useCallback(async() => {
      const payload = {
        "template": "Worldify-Welcome-Email",
        "send_to": `c.cantero@multiplymii.com`,
        "contents": {
          "name": `Cedrick Cantero`,
          "document_link": `https://multiplymii.com`
        }
      }
      sendEmail(payload)
      .then((response) => {
        if (response?.headers['rate-limit-token'] && response?.headers['rate-limit-refresh-token']) {
          sso(response?.headers['rate-limit-token'], response?.headers['rate-limit-refresh-token']);
        }
      })
      .catch((error) => {
        refreshLimitToken(refresh)
      })
  }, [])

  const handleTestRefreshToken = useCallback(async() => {
     refreshLimitToken(refresh)
     .then((response)=> {
      if(response){
        sso(response.token,response.refresh_token, response.role)
      }
     })
  }, []);

  const handleTestRemoveToken = () => {
    console.log("token", getCookie('tkn-ath'));
    console.log("token-refresh", getCookie('tkn-ath-rfrsh'));
    console.log("token-role", getCookie('tkn-ath-role'));
    sessionStorage.removeItem('token');
    setCookie('tkn-ath', "")
    setCookie('tkn-ath-rfrsh', "")
    setCookie('tkn-ath-role', "")
    console.log("token", getCookie('tkn-ath'));
    console.log("token-refresh", getCookie('tkn-ath-rfrsh'));
    console.log("token-role", getCookie('tkn-ath-role'));
  }

  const handleTestSendToHubspot = useCallback(async() => {
    const testPayLoad = {
      firstName: `Test ${buildMiiFirstNameList[Math.floor( Math.random() * buildMiiFirstNameList.length )]} `,
      lastName: `Test ${buildMiiLastNameList[Math.floor( Math.random() * buildMiiLastNameList.length )]} `,
      position:'Test Developer',
      company: 'Test Company',
      email: `Test${buildMiiFirstNameList[Math.floor( Math.random() * buildMiiFirstNameList.length )]}${buildMiiLastNameList[Math.floor( Math.random() * buildMiiLastNameList.length )]}@gmail.com`,
    }

    const testRole = "Senior PPC"
    
      sendToHubspot(testPayLoad, testRole)
      .then((response)=> {
        if(response){
          console.log("response", response)
          refreshLimitToken(refresh)
          .then((response)=> {
          if(response){
            sso(response.token,response.refresh_token, response.role)
          }
          })
        }
      }).catch((error)=> {
        console.log("error", error)
      })
  }, []);

    return(
        <>
        <div className="flex flex-col min-h-[60vh]">
          <div className="flex flex-row w-full h-full bg-white-900 pt-[2rem] px-[2rem] ">
            <div className="flex flex-row h-[10%]  py-2 px-4 mt-4 justify-center gap-4">
              <div className="flex flex-col items-center ">
                <button 
                    className="bg-white-500 hover:bg-gray-300  border-[2px] border-themeColor-100 text-themeColor-200 font-bold py-2 px-4 rounded-full"
                    onClick={handleTestResponseService}
                >
                    Test Get Typeform Response Service
                </button>
              </div>
              <div className="flex flex-col items-center ">
                <button 
                    className="bg-white-500 hover:bg-gray-300  border-[2px] border-themeColor-100 text-themeColor-200 font-bold py-2 px-4 rounded-full"
                    onClick={handleTestConfigService}
                >
                    Test Get Typeform Config Service
                </button>
              </div>
              <div className="flex flex-col items-center ">
                <button 
                    className="bg-white-500 hover:bg-gray-300  border-[2px] border-themeColor-100 text-themeColor-200 font-bold py-2 px-4 rounded-full"
                    onClick={handleTestChatService}
                >
                  Test Post Chat Service
                </button>
              </div>
              <div className="flex flex-col items-center ">
                <TemplateUploader/>
              </div>
              <div className="flex flex-col items-center ">
                <button 
                    className="bg-white-500 hover:bg-gray-300  border-[2px] border-themeColor-100 text-themeColor-200 font-bold py-2 px-4 rounded-full"
                    onClick={handleTestSendEmailService}
                >
                  Test Send Email Service
                </button>
              </div>
            </div>
          </div>
          <div className="flex flex-row w-full h-full bg-white-900 pt-[2rem] px-[2rem] ">
            <div className="flex flex-row h-[10%]  py-2 px-4 mt-4 justify-center gap-4">
              <div className="flex flex-col items-center ">
                <button 
                    className="bg-white-500 hover:bg-gray-300  border-[2px] border-themeColor-100 text-themeColor-200 font-bold py-2 px-4 rounded-full"
                    onClick={handleTestRefreshToken}
                >
                  Test Refresh Token Service
                </button>
              </div>
              <div className="flex flex-col items-center ">
              <button 
                    className="bg-white-500 hover:bg-gray-300  border-[2px] border-themeColor-100 text-themeColor-200 font-bold py-2 px-4 rounded-full"
                    onClick={handleTestRemoveToken}
                >
                  Test Remove Token
                </button>
              </div>
              <div className="flex flex-col items-center ">
              <button 
                    className="bg-white-500 hover:bg-gray-300  border-[2px] border-themeColor-100 text-themeColor-200 font-bold py-2 px-4 rounded-full"
                    onClick={handleTestSendToHubspot}
                >
                  Test Hubspot Service
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    )
}

export default BuildMiiTestPage